import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { useWidgetContext } from 'widgets/WidgetContext';
import { PerfVsIndexCapsuleConfigState } from 'widgets/perfVsIndexCapsule/store/config/PerfVsIndexCapsuleConfigState';
import { buildPerfVsIndexData } from 'widgets/perfVsIndexCapsule/perfVsIndexCapsuleData';
import { PerfVsIndexCapsuleContent } from 'widgets/perfVsIndexCapsule/components/PerfVsIndexCapsuleContent';
import { useFillsGraphStreamedData } from 'widgets/fillsGraph/store/streamedData/hooks';
import { useFillsGraphDataIndexDescription } from 'widgets/fillsGraph/store/data/hooks';

export function PerfVsIndexCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<PerfVsIndexCapsuleConfigState>();
    const { widgetKey } = useWidgetContext();

    const { showDataFor, indexFallback } = config;

    const { streamedData, streamKey } = useFillsGraphStreamedData(
        symbol,
        indexFallback
    );

    const streamData = streamedData?.data;
    const data = buildPerfVsIndexData({ streamData, showDataFor });

    const indexDescription = useFillsGraphDataIndexDescription(
        streamedData?.data
    );

    const index = symbol && indexDescription ? indexDescription : '';

    return (
        <PerfVsIndexCapsuleContent
            data-stream-key={streamKey}
            data={data}
            config={config}
            index={index}
            dispatchConfigChanged={dispatchConfigChanged}
            symbol={symbol}
            capsuleKey={`${widgetKey}=${symbol}`}
        />
    );
}
